import type {
  ChatPromptContext,
  ChatPromptContextEntityType,
} from '@flux/iara-core/prompt-context';
import { ChatPromptContextEntityType as GqlEntityType } from '@generated/graphql';
import type { ChatPromptContextInput } from '@generated/graphql';

/**
 * Ponte para o enum GraphQL, derivada dos VALORES do próprio enum gerado.
 *
 * O codegen usa chaves PascalCase (`Card`) com valores minúsculos (`'card'`), que
 * são exatamente os tipos da fonte única — então indexar pelo valor é seguro e
 * dispensa um mapa escrito à mão. `to-send-message-context.spec.ts` prova a
 * paridade entre o enum gerado e `CHAT_PROMPT_CONTEXT_ENTITY_TYPES`.
 */
const GQL_ENTITY_TYPE = Object.fromEntries(
  Object.values(GqlEntityType).map((value) => [value, value]),
) as Record<ChatPromptContextEntityType, GqlEntityType>;

/**
 * Converte o contexto derivado da tela no input GraphQL. Retorna `undefined` quando
 * não há nada de útil (nem entidade identificável, nem rótulo de tela) — enviar um
 * contexto vazio só gastaria payload.
 */
export function toSendMessageContext(
  context: ChatPromptContext,
): ChatPromptContextInput | undefined {
  const entities = context.entities.filter((entity) => entity.id ?? entity.label);

  if (entities.length === 0 && !context.screen) return undefined;

  return {
    entities: entities.map((entity) => ({
      id: entity.id,
      label: entity.label,
      type: GQL_ENTITY_TYPE[entity.type],
    })),
    route: context.route,
    screen: context.screen,
  };
}
